<template>
    <div>
        <hr/>

        <div class="dropdown-container" :class="[content.graded, {'graded': content.graded, 'reveal': content.reveal}]">

            <h4 class="graded-response correct" v-if="content.graded === 'correct'"><i class="fas fa-check-circle mr-3"></i>Correct</h4>
            <h4 class="graded-response incorrect" v-if="content.graded === 'incorrect'"><i class="fas fa-times-circle mr-3"></i>Incorrect</h4>

            <div class="top-area" v-if="content.areas[0].content">
                <render-editor-js :content="content.areas[0].content" :component="{}"/>
            </div>

            <b-field class="text-input-field" :message="(content.required) ? '* Response is required.' : ''">
                <b-select expanded v-model="data[content.id]" :required="content.required" @input="saveData" :disabled="content.graded">
                    <option :value="opt.option" v-for="opt in content.options">{{opt.option}}</option>
                </b-select>
            </b-field>

            <div class="bottom-area" v-if="content.areas[1].content">
                <render-editor-js :content="content.areas[1].content" :component="{}"/>
            </div>
        </div>
    </div>
</template>

<script>

    import RenderEditorJs from "./RenderEditorJs.vue";

    export default {
        components: {RenderEditorJs},
        props: ['content', 'data'],
        methods: {
            saveData() {
                this.$emit('saveData', {
                    block: JSON.stringify(this.content),
                    field: this.content.id,
                    value: this.data[this.content.id]
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .dropdown-container {
        border: 1px solid transparent;
        border-radius: 0.3rem;

        &.graded {

            &.incorrect {
                border-color: #be1313 !important;
            }

            &.correct {
                border-color: green !important;
            }
        }

        .graded-response {
            display: none;
            padding: 0.3rem 1.2rem;
            font-size: 1rem;

            &.correct {
                display: block;
                background-color: green;
                color: white;
                padding: 0.6rem 1.7rem;
            }

            &.incorrect {
                display: block;
                background-color: #be1313;
                color: white;
                padding: 0.6rem 1.7rem;
            }
        }
    }

</style>

<style lang="scss">
    .text-input-field {
        padding: 0 2rem 1.2rem;
    }

    .top-area {
        .render-paragraph {
            margin-bottom: 0 !important;
            padding-bottom: 10px !important;
        }
    }
</style>
